import { render, staticRenderFns } from "./DealFilterMobile.vue?vue&type=template&id=10d50c8e&scoped=true"
import script from "./DealFilterMobile.vue?vue&type=script&lang=js"
export * from "./DealFilterMobile.vue?vue&type=script&lang=js"
import style0 from "./DealFilterMobile.vue?vue&type=style&index=0&id=10d50c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d50c8e",
  null
  
)

export default component.exports